import { AppBar, Box, Container, Divider, Typography } from "@mui/material";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Fragment } from "react";

export default function AdminFooter() {
  return (
    <Fragment>
      <Box
        sx={{
          backgroundColor: "black",
          height: "6vh",
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
        }}
      >
        <Container
          sx={{
            width: "100%",
            height: "auto",
            paddingTop: "1rem",
            paddingBottom: "1rem",
          }}
        >
          <Box
            sx={{
              color: "white",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box display="flex" alignItems="center">
              <CopyrightIcon style={{ marginRight: 8 }} />
              <Typography>2024 - GDPL</Typography>
            </Box>
            Offical Partner of Travelport
          </Box>
        </Container>
      </Box>
    </Fragment>
  );
}
